/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Import_Select_Source_File_LabelInputs */



/**
* | output |
* | --- |
* | "Select Source Subtitle File" |
*
* @param {Translation_Import_Select_Source_File_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_import_select_source_file_label = /** @type {((inputs?: Translation_Import_Select_Source_File_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Import_Select_Source_File_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionner le fichier de sous-titres source")
	if (locale === "de") return /** @type {LocalizedString} */ ("Quell-Untertiteldatei auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona il file sorgente dei sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите исходный файл субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione el archivo de subtítulos de origen.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择源字幕文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ソース字幕ファイルを選択してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्रोत उपशीर्षक फ़ाइल चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o arquivo de legenda de origem")
	return /** @type {LocalizedString} */ ("Select Source Subtitle File")
});